export enum HallowAnalyticsEvent {
  AdminAssigned = "Admin Assigned",
  AudioStartDelayed = "Audio Start Delayed",
  AudioStarted = "Audio Started",
  AutocompletedPhoneNumber = "Autocompleted Phone Number",
  BibleCompleted = "Bible Completed",
  BibleStarted = "Bible Started",
  CategoriesCompleted = "Categories Completed",
  CategoriesStarted = "Categories Started",
  ChangedBibleChapter = "Changed Bible Chapter",
  ChangedTranscriptAutoScrollSetting = "Changed Transcript Auto Scroll Setting",
  ChangedTranscriptTextSizeSetting = "Changed Transcript Text Size Setting",
  ChangedTranscriptColorSetting = "Changed Transcript Color Setting",
  Close = "Close",
  ClosedShareAudioView = "Closed Share Audio View",
  CollectionFavorited = "Collection Favorited",
  CommunityReportResponded = "Community Report Responded",
  CommunityReportedActivityDeleted = "Community Reported Activity Deleted",
  CompletedOnboardingStep = "Completed Onboarding Step",
  CreatedNotreDameEmailAccount = "Created Notre Dame Email Account",
  DonationPurchased = "Donation Purchased",
  DraggedFeaturedSessionOrder = "Dragged Featured Session Order",
  DraggedQueueItem = "Dragged Queue Item",
  DraggedTimeSlider = "Dragged Time Slider",
  EditedJournal = "Edited Journal",
  EnteredEmailVerification = "Entered Email Verification",
  HeraldPrizeRedemptionClicked = "Herald Prize Redemption Clicked",
  HeraldPrizeRedemptionSubmitted = "Herald Prize Redemption Submitted",
  LoopChanged = "Loop Changed",
  MaximizedPlayer = "Maximized Player",
  MinimizedPlayer = "Minimized Player",
  OpenedBibleBookMenu = "Opened Bible Book Menu",
  OpenedBibleChapterMenu = "Opened Bible Chapter Menu",
  PlayerBeganTrack = "Player Began Track",
  PlayerDestroyed = "Player Destroyed",
  PlayerEndedTrack = "Player Ended Track",
  PlayerInitialized = "Player Initialized",
  PostedContentToCommunity = "Posted Content to Community",
  RemovedPost = "Removed Post",
  SelectedAssignmentCollection = "Selected Assignment Collection",
  SelectedBibleTranslation = "Selected Bible Translation",
  SelectedChoice = "Selected Choice",
  SelectedRecommendationChoice = "Selected Recommendation Choice",
  SelectedSubtitles = "Selected Subtitles",
  SelectedTriviaChoice = "Selected Trivia Choice",
  ShowNative = "Show Native",
  SkippedOnboardingStep = "Skipped Onboarding Step",
  SubmittedCancellationFeedback = "Submitted Cancellation Feedback",
  SubmittedOtherCancellationFeedback = "Submitted Other Cancellation Feedback",
  SubmittedNotreDameForm = "Submitted Notre Dame Form",
  SubscribedNotreDameUser = "Subscribed Notre Dame User",
  SubscriptionPurchased = "Subscription Purchased",
  SubscriptionUpgraded = "Subscription Upgraded",
  TappedAddAssignment = "Tapped Add Assignment",
  TappedAddContentToCommunity = "Tapped Add Content to Community",
  TappedAddClass = "Tapped Add Class",
  TappedAddClassMember = "Tapped Add Class Member",
  TappedAddDueDate = "Tapped Add Due Date",
  TappedAddToFeatured = "Tapped Add to Featured",
  TappedAddMember = "Tapped Add Member",
  TappedAddFriendToFamilyPlan = "Tapped Add Friend to Family Plan",
  TappedAddFamilyToFamilyPlan = "Tapped Add Family to Family Plan",
  TappedAddChildToFamilyPlan = "Tapped Add Child to Family Plan",
  TappedCreateChildAccount = "Tapped Create Child Account",
  TappedAddPartnershipContent = "Tapped Add Partnership Content",
  TappedAddStudent = "Tapped Add Student",
  TappedAddTeacher = "Tapped Add Teacher",
  TappedAddToRoutine = "Tapped Add to Routine",
  TappedAdminDashboardTab = "Tapped Admin Dashboard Tab",
  TappedApplePay = "Tapped Apple Pay",
  TappedApplyPromoCode = "Tapped Apply Promo Code",
  TappedAssignAsMember = "Tapped Assign As Member",
  TappedAssignAsAdmin = "Tapped Assign As Admin",
  TappedAssignment = "Tapped Assignment",
  TappedAssignmentOption = "Tapped Assignment Option",
  TappedAssignmentSearch = "Tapped Assignment Search",
  TappedBack = "Tapped Back",
  TappedBannerDownload = "Tapped Banner Download",
  TappedModalDownload = "Tapped Modal Download",
  TappedBibleBook = "Tapped Bible Book",
  TappedBibleChapter = "Tapped Bible Chapter",
  TappedBibleTranslations = "Tapped Bible Translations",
  TappedBroadcastMessageEditorGroups = "Tapped Broadcast Message Editor Groups",
  TappedBuyGift = "Tapped Buy Gift",
  TappedBuyNow = "Tapped Buy Now",
  TappedCampaignOption = "Tapped Campaign Option",
  TappedCampaignSession = "Tapped Campaign Session",
  TappedCancelSubscription = "Tapped Cancel Subscription",
  TappedCategoriesSummary = "Tapped Categories Summary",
  TappedClassAssignments = "Tapped Class Assignments",
  TappedClassOption = "Tapped Class Option",
  TappedClassRoster = "Tapped Class Roster",
  TappedClassSearch = "Tapped Class Search",
  TappedClose = "Tapped Close",
  TappedCloseCategories = "Tapped Close Categories",
  TappedCloseTheWord = "Tapped Close The Word",
  TappedCommunityMemberOptions = "Tapped Community Member Options",
  TappedCommunityMemberProfile = "Tapped Community Member Profile",
  TappedCommunityPermissionsToggle = "Tapped Community Permissions Toggle",
  TappedCommunityReportInfo = "Tapped Community Report Info",
  TappedCommunitySettings = "Tapped Community Settings",
  TappedConfirmDOB = "Tapped Confirm DOB",
  TappedContentCategory = "Tapped Content Category",
  TappedContinue = "Tapped Continue",
  TappedContinueToCancellation = "Tapped Continue to Cancellation",
  TappedContactHallowParishLead = "Tapped Contact Hallow Parish Lead",
  TappedCreateEvent = "Tapped Create Event",
  TappedCreditOrDebitCard = "Tapped Credit or Debit Card",
  TappedDashboardChartTimeframe = "Tapped Dashboard Chart Timeframe",
  TappedDeleteBroadcastMessage = "Tapped Delete Broadcast Message",
  TappedDeleteMember = "Tapped Delete Member",
  TappedDeselectAllTiles = "Tapped Deselect All Tiles",
  TappedDetails = "Tapped Details",
  TappedDiscardBroadcastMessage = "Tapped Discard Broadcast Message",
  TappedDiscover = "Tapped Discover",
  TappedDonationAddNote = "Tapped Donation Add Note",
  TappedDownloadCSVTemplate = "Tapped Download CSV Template",
  TappedDownloadOnTheAppStore = "Tapped Download on the App Store",
  TappedEdit = "Tapped Edit",
  TappedEventSection = "Tapped Event Section",
  TappedEditMember = "Tapped Edit Member",
  TappedExitInCancellationFlow = "Tapped Exit in Cancellation Flow",
  TappedExitOnEditMember = "Tapped Exit on Edit Member",
  TappedExplorePrayers = "Tapped Explore Prayers",
  TappedExploreMorePrayers = "Tapped Explore More Prayers",
  TappedExportCSV = "Tapped Export CSV",
  TappedExportJournalsSettings = "Tapped Export Journals Settings",
  TappedExportSupporterCSV = "Tapped Export Supporter CSV",
  TappedExportTXT = "Tapped Export TXT",
  TappedFastForward = "Tapped Fast Forward",
  TappedFollowAudio = "Tapped Follow Audio",
  TappedGCash = "Tapped GCash",
  TappedGetItOnGooglePlay = "Tapped Get it on Google Play",
  TappedGivingEmailCheckbox = "Tapped Giving Email Checkbox",
  TappedGivingFeeCoverageCheckbox = "Tapped Giving Fee Coverage Checkbox",
  TappedGooglePay = "Tapped Google Pay",
  TappedGroup = "Tapped Group",
  TappedGroupInvite = "Tapped Group Invite",
  TappedGroupMembers = "Tapped Group Members",
  TappedHaveAPromoCode = "Tapped Have a Promo Code",
  TappedImportStudents = "Tapped Import Students",
  TappedImportTeachers = "Tapped Import Teachers",
  TappedInviteFriends = "Tapped Invite Friends",
  TappedInviteFriendsToTrivia = "Tapped Invite Friends to Trivia",
  TappedJoinCampaign = "Tapped Join Campaign",
  TappedJoinChallenge = "Tapped Join Challenge",
  TappedLeaveGroup = "Tapped Leave Group",
  TappedListenForFree = "Tapped Listen for Free",
  TappedLogBackIn = "Tapped Log Back In",
  TappedLogOut = "Tapped Log Out",
  TappedLogin = "Tapped Log In",
  TappedMagicLinkHelp = "Tapped Magic Link Help",
  TappedMakeADonation = "Tapped Make a Donation",
  TappedMemberOption = "Tapped Member Option",
  TappedMemberSearch = "Tapped Member Search",
  TappedMergeAccountsSendVerification = "Tapped Merge Accounts Send Verification",
  TappedModalPrimaryCTA = "Tapped Modal Primary CTA",
  TappedModalSecondaryCTA = "Tapped Modal Secondary CTA",
  TappedMoreGame = "Tapped More Game",
  TappedMoreGamesItem = "Tapped More Games Item",
  TappedNewJournal = "Tapped New Journal",
  TappedNextUp = "Tapped Next Up",
  TappedNotNowOnSMSPrompt = "Tapped Not Now on SMS Prompt",
  TappedPause = "Tapped Pause",
  TappedPaymentApplePay = "Tapped Apple Pay",
  TappedPaymentCard = "Tapped Card",
  TappedPaymentGooglePay = "Tapped Google Pay",
  TappedPaymentPaypal = "Tapped Paypal",
  TappedPaypal = "Tapped Paypal",
  TappedPlay = "Tapped Play",
  TappedPlayAll = "Tapped Play All",
  TappedPlayNextSession = "Tapped Play Next Session",
  TappedPlayRadioStation = "Tapped Play Radio Station",
  TappedPlaySession = "Tapped Play Session",
  TappedPlayVideo = "Tapped Play Video",
  TappedPrayerInCancellation = "Tapped Prayer in Cancellation",
  TappedPrayTodaysSession = "Tapped Pray Todays Session",
  TappedPrimaryCTA = "Tapped Primary CTA",
  TappedQueue = "Tapped Queue",
  TappedQueueItem = "Tapped Queue Item",
  TappedRedeemGiftSubscription = "Tapped Redeem Gift Subscription",
  TappedReflectOnPostPrayer = "Tapped Reflect on Post Prayer",
  TappedRefreshApp = "Tapped Refresh App",
  TappedRegiftGiftSubscription = "Tapped Regift Gift Subscription",
  TappedRefundSubscription = "Tapped Refund Subscription",
  TappedRemoveMember = "Tapped Remove Member",
  TappedReportATranscriptConcern = "Tapped Report a Transcript Concern",
  TappedReportReason = "Tapped Report Reason",
  TappedRemindMeOnSMSPrompt = "Tapped Remind Me on SMS Prompt",
  TappedRemoveCommunityMember = "Tapped Remove Community Member",
  TappedRemovePost = "Tapped Remove Post",
  TappedRestoreSubscriptions = "Tapped Restore Subscriptions",
  TappedResumeCategories = "Tapped Resume Categories",
  TappedResumeSession = "Tapped Resume Session",
  TappedResumeTheWord = "Tapped Resume The Word",
  TappedResumeTrivia = "Tapped Resume Trivia",
  TappedReviewInSettings = "Tapped Review in Settings",
  TappedRewind = "Tapped Rewind",
  TappedPremiumContentToggle = "Tapped Premium Content Toggle",
  TappedSaveEventDate = "Tapped Save Event Date",
  TappedSaveEventDescription = "Tapped Save Event Description",
  TappedSaveEventHosts = "Tapped Save Event Hosts",
  TappedSaveEventImage = "Tapped Save Event Image",
  TappedSaveEventLocation = "Tapped Save Event Location",
  TappedSaveEventType = "Tapped Save Event Type",
  TappedSaveOnEditMember = "Tapped Save on Edit Member",
  TappedSecondaryCTA = "Tapped Secondary CTA",
  TappedSectionActionButton = "Tapped Section Action Button",
  TappedSectionItem = "Tapped Section Item",
  TappedSectionItemMoreMenu = "Tapped Section Item More Menu",
  TappedSectionSeeAll = "Tapped Section See All",
  TappedSelectAllPrayersforAssignment = "Tapped Select All Prayers for Assignment",
  TappedSelectPrayerforAssignment = "Tapped Select Prayer for Assignment",
  TappedSelectSubscriptionPlan = "Tapped Select Subscription Plan",
  TappedSendBroadcastMessage = "Tapped Send Broadcast Message",
  TappedSentBroadcastMessageGroups = "Tapped Sent Broadcast Message Groups",
  TappedShareCampaign = "Tapped Share Campaign",
  TappedShareCampaignSessionCount = "Tapped Share Campaign Session Count",
  TappedShareCategories = "Tapped Share Categories",
  TappedShareChallenge = "Tapped Share Challenge",
  TappedShareCollection = "Tapped Share Collection",
  TappedShareTrivia = "Tapped Share Trivia",
  TappedShareTheWord = "Tapped Share The Word",
  TappedShuffle = "Tapped Shuffle",
  TappedShuffleAll = "Tapped Shuffle All",
  TappedShuffleTiles = "Tapped Shuffle Tiles",
  TappedSkip = "Tapped Skip",
  TappedSkipBack = "Tapped Skip Back",
  TappedSkipForward = "Tapped Skip Forward",
  TappedSkipIntro = "Tapped Skip Intro",
  TappedSleepTimer = "Tapped Sleep Timer",
  TappedStartCategories = "Tapped Start Categories",
  TappedStartCreateEvent = "Tapped Start Create Event",
  TappedStartTheWord = "Tapped Start The Word",
  TappedStartTrivia = "Tapped Start Trivia",
  TappedSubmitStripe = "Tapped Submit Stripe",
  TappedSubscribeToListen = "Tapped Subscribe to Listen",
  TappedSubscribeToWatch = "Tapped Subscribe to Watch",
  TappedRemoveCommunityContent = "Tapped Remove Community Content",
  TappedTextOnScreen = "Tapped Text on Screen",
  TappedTheWordSummary = "Tapped The Word Summary",
  TappedToAcceptOffer = "Tapped to Accept Offer",
  TappedToCompleteImport = "Tapped to Complete Import",
  TappedToDeclineOffer = "Tapped to Decline Offer",
  TappedTrackSettings = "Tapped Track Settings",
  TappedTranscriptSettings = "Tapped Transcript Settings",
  TappedTranscriptOption = "Tapped Transcript Option",
  TappedTranscriptText = "Tapped Transcript Text",
  TappedTriviaRecommendation = "Tapped Trivia Recommendation",
  TappedTriviaSummary = "Tapped Trivia Summary",
  TappedTriviaWeeklyLeaderboard = "Tapped Trivia Weekly Leaderboard",
  TappedTryHallowForFree = "Tapped Try Hallow for Free",
  TappedUnlinkSmallGroup = "Tapped Unlink Small Group",
  TappedUpdateGivingCampaign = "Tapped Update Giving Campaign",
  TappedUseEmailInstead = "Tapped Use Email Instead",
  TappedUsePasswordInstead = "Tapped Use Password Instead",
  TappedViewDetails = "Tapped View Details",
  TappedWatchForFree = "Tapped Watch for Free",
  TappedWebAppTabBar = "Tapped Web App Tab Bar",
  TappedWebAppNav = "Tapped Web App Nav",
  TappedWebCommunity = "Tapped Web Community",
  TappedWebCommunityDropdown = "Tapped Web Community Dropdown",
  TappedWriteBroadcastMessage = "Tapped Write Broadcast Message",
  TheWordCompleted = "The Word Completed",
  TheWordStarted = "The Word Started",
  TimerChanged = "Timer Changed",
  TimerEnded = "Timer Ended",
  ToggledFreeTrial = "Toggled Free Trial",
  ToggledStreakSettings = "Toggled Streak Settings",
  ToggledSubscriptionType = "Toggled Subscription Type",
  ToggledTrialReminder = "Toggled Trial Reminder",
  ToggledUseSameDateForAllAssignments = "Toggled Use Same Date for All Assignments",
  ToggledViewOrderSummary = "Tapped View Order Summary",
  TookPostPrayerScreenAction = "Took Post Prayer Screen Action",
  TrackPayment = "Track Payment",
  TriviaCompleted = "Trivia Completed",
  TriviaStarted = "Trivia Started",
  VerifiedNotreDameCaptcha = "VerifiedNotreDameCaptcha",
  VideoEnded = "Video Ended",
  ViewedAdminDashboardScreen = "Viewed Admin Dashboard Screen",
  ViewedCancellationFeedback = "Viewed Cancellation Feedback",
  ViewedCancellationOffer = "Viewed Cancellation Offer",
  ViewedCancelSubscription = "Viewed Cancel Subscription",
  ViewedFollowAudioButton = "Viewed Follow Audio Button",
  ViewedImportError = "Viewed Import Error",
  ViewedJournalEntry = "Viewed Journal Entry",
  ViewedModal = "Viewed Modal",
  ViewedNotreDameRegister = "Viewed Notre Dame Register",
  ViewedPostPrayerScreen = "Viewed Post Prayer Screen",
  ViewedRefundSubscription = "Viewed Refund Subscription",
  ViewedScreen = "Viewed Screen",
  ViewedShareChallengeDialog = "Viewed Share Challenge Dialog",
  ViewedShareCollectionDialog = "Viewed Share Collection Dialog",
  ViewedSMSPromptDialog = "Viewed SMS Prompt Dialog",
  ViewedSubscriptionPlans = "Viewed Subscription Plans",
  ViewedSubscriptionScreen = "Viewed Subscription Screen",
  ViewedTextOnScreen = "Viewed Text on Screen",
  TappedSearchCommunityLibrary = "Tapped Search Community Library",
}
